import { useMutation } from '@tanstack/react-query'
import { FingerprintFlows, useFingerprint } from 'hooks/useFingerprint'
import { postLogin } from 'services/AuthService'
import { PostLoginReq } from 'types/authentication/PostLoginReq'
import { logError } from 'utils/sentry'

export const useLoginMutation = () => {
  const { getFingerprintEventId } = useFingerprint()

  return useMutation({
    mutationFn: async (postData: PostLoginReq) => {
      const fingerprintEventId = await getFingerprintEventId(FingerprintFlows.LOGIN).catch(
        error => {
          logError('Error from useLoginMutation - getFingerprintEventId', error)
          return ''
        }
      )
      return postLogin({ ...postData, fingerprintEventId })
    },
  })
}
